import { render } from "./guide-detail.vue?vue&type=template&id=723bdd79&scoped=true"
import script from "./guide-detail.vue?vue&type=script&lang=js"
export * from "./guide-detail.vue?vue&type=script&lang=js"

import "./guide-detail.vue?vue&type=style&index=0&id=723bdd79&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723bdd79"]])

export default __exports__